import React, { createContext, useContext, useMemo } from "react";

import PropTypes from "prop-types";
import { useSelector } from "react-redux";

const PrivyContext = createContext({
  loginMethods    : ["email"],
  setLoginMethods : () => {},
});

export const usePrivyContext = () => {
  const context = useContext(PrivyContext);
  if (!context) {
    throw new Error("usePrivyContext must be used within a PrivyContextProvider");
  }
  return context;
};

export const PrivyContextProvider = ({ children }) => {
  const loginMethods = useSelector(store => store.global?.privyLogin || ["email"]);

  const contextValue = useMemo(() => ({
    loginMethods,
    setLoginMethods: () => {}
  }), [loginMethods]);

  return (
    <PrivyContext.Provider value={contextValue}>
      {children}
    </PrivyContext.Provider>
  );
};

PrivyContextProvider.propTypes = {
  children: PropTypes.node
};

export { PrivyContext };
